import { AfterViewInit, Directive, ElementRef, inject, Input } from "@angular/core";
import { FilterType, PreviewItemFilterOption } from "./preview-item-filter-option";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { PreviewItemFilters } from "./preview-item-filters";
import { Router } from "@angular/router";

@Directive()
export class PreviewItemFilterOptionComponent implements AfterViewInit {
    @Input({ required: true }) public itemFilters!: PreviewItemFilters;
    @Input({ required: true }) public filterOption!: PreviewItemFilterOption;

    protected selfRef: ElementRef = inject(ElementRef);
    protected events: EventBroker = inject(EventBroker);
    protected router: Router = inject(Router);

    private shouldReloadOption: boolean = true;
    protected page: string = "";

    public ngOnInit(): void {
        this.page = this.router.url;
    }

    public ngAfterViewInit(): void {
        this.loadStoredOption();
    }

    public ngOnDestroy(): void {
        
    }

    public getOptions(): Map<string, number | undefined> {
        return this.filterOption.getFilters();
    }

    public update(value: string): void {
        if (this.filterOption.updateSelection(value, this.page)) {
            this.events.ui.previewFilterChangeEvent.emit(this.itemFilters);
        }
    }

    public loadStoredOption(): void {
        this.shouldReloadOption = this.shouldReloadOption || this.filterOption.filterType == FilterType.Sort;

        if (!this.shouldReloadOption) {
            return;
        }

        this.shouldReloadOption = false;
        var storedFilter = this.filterOption.loadStoredFilter(this.page);

        if (storedFilter) {
            this.loadStoredOptionValue(storedFilter);
            this.events.ui.previewFilterChangeEvent.emit(this.itemFilters);
        }
    }

    protected loadStoredOptionValue(value: string) {
        // ... implement in child ... 
    }

    protected trySetSelectedOption(selectRef: HTMLSelectElement, value: string): void {
        for (let i = 0; i < selectRef.options.length; ++i) {
            if (selectRef.options[i].value === value) {
                selectRef.value = value;
                break;
            }
        }
    }
}